import { Controller } from "@hotwired/stimulus";

const MAX_ROWS = 30;

// Generic inline list controller for simple label-only rows.
// Each row has inputs with data-field attributes; the whole list is
// serialized to a hidden JSON input (data-inline-crud-target="json").
export default class InlineCrudController extends Controller {
  static targets = ["list", "row", "json"];
  static values = {
    fieldPlaceholder: String,
    removeAriaLabel: String,
  };

  connect() {
    this.#serialize();
  }

  addRow() {
    if (this.rowTargets.length >= MAX_ROWS) return;

    const tpl = this.element.querySelector("template[data-inline-crud-row]");
    let el;
    if (tpl) {
      el = tpl.content.cloneNode(true).firstElementChild;
    } else {
      el = document.createElement("div");
      el.className = "flex items-center gap-2 mb-1";
      el.dataset.inlineCrudTarget = "row";
      el.innerHTML = `
        <input type="text" class="input input-bordered input-xs flex-1"
               data-field="label"
               data-action="input->inline-crud#onChange">
        <button type="button"
                class="btn btn-ghost btn-xs btn-square text-error/70 hover:text-error"
                data-action="click->inline-crud#removeRow">
          <i class="fa-solid fa-trash-can"></i>
        </button>
      `;
      el.querySelector("input").placeholder = this.fieldPlaceholderValue;
      el.querySelector("button").setAttribute("aria-label", this.removeAriaLabelValue || "Remove");
    }
    this.listTarget.appendChild(el);
    this.#serialize();
  }

  removeRow(event) {
    event.currentTarget.closest("[data-inline-crud-target='row']")?.remove();
    this.#serialize();
  }

  onChange() {
    this.#serialize();
  }

  #serialize() {
    const rows = this.rowTargets
      .map((row) => {
        const obj = {};
        row.querySelectorAll("[data-field]").forEach((input) => {
          obj[input.dataset.field] = input.value;
        });
        return obj;
      })
      .filter((obj) => Object.values(obj).some((v) => v.trim() !== ""));

    if (this.hasJsonTarget) {
      this.jsonTarget.value = JSON.stringify(rows);
    }
  }
}
